import type { JSXElement } from "solid-js"
import { Show } from "solid-js"
import { authCard, authContainer } from "./auth-layout.css"

type Props = {
  children: JSXElement
  header?: JSXElement
}

export function AuthLayout(props: Props) {
  return (
    <div class={authContainer}>
      <div class={authCard}>
        <Show when={props.header}>{props.header}</Show>

        {props.children}
      </div>
    </div>
  )
}
